module.exports = __webpack_public_path__ + "media/images/newbies-rocket_people-871bb7981fe05f938381efd3840bb9c7.webp";